/* Free Life Labs — Shop page behaviour
   Retail: category filter, variant pick, qty stepper, AJAX add (Seal selling plan respected).
   Wholesale: quick-order tiers, running subtotal, free-shipping progress, materials + samples.
   Prices are read from the DOM so Sami's rewritten storefront prices are used, not hardcoded values. */
(function () {
  "use strict";

  var money = function (cents, format) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return (format || "${{amount}}").replace("{{amount}}", parts.join("."));
  };

  function init(root) {
    if (!root || root.dataset.flsReady === "true") return;
    root.dataset.flsReady = "true";

    var settings = JSON.parse(root.querySelector("[data-fls-settings]").textContent);
    var moneyFormat = settings.moneyFormat;
    var freeShipping = settings.freeShippingCents;

    /* ---------------- category filter ---------------- */
    var areaButtons = root.querySelectorAll("[data-fls-area]");
    var cards = root.querySelectorAll("[data-fls-card]");
    var resultsCount = root.querySelector("[data-fls-count]");
    var clearBtn = root.querySelector("[data-fls-clear]");
    var activeArea = "all";

    function applyFilter() {
      var shown = 0;
      cards.forEach(function (card) {
        var match = activeArea === "all" || card.dataset.flsArea === activeArea;
        card.hidden = !match;
        if (match) shown++;
      });
      areaButtons.forEach(function (btn) {
        btn.setAttribute("aria-pressed", String(btn.dataset.flsArea === activeArea));
      });
      if (resultsCount) {
        var label = root.querySelector('[data-fls-area="' + activeArea + '"]');
        resultsCount.textContent =
          activeArea === "all"
            ? "All products (" + shown + ")"
            : (label ? label.dataset.flsAreaName : "") + " (" + shown + ")";
      }
      if (clearBtn) clearBtn.hidden = activeArea === "all";
    }

    areaButtons.forEach(function (btn) {
      btn.addEventListener("click", function () {
        activeArea = activeArea === btn.dataset.flsArea ? "all" : btn.dataset.flsArea;
        applyFilter();
      });
    });
    if (clearBtn) {
      clearBtn.addEventListener("click", function () {
        activeArea = "all";
        applyFilter();
      });
    }
    if (areaButtons.length) applyFilter();

    /* ---------------- steppers ---------------- */
    root.addEventListener("click", function (event) {
      var step = event.target.closest("[data-fls-step]");
      if (!step) return;
      var wrap = step.closest("[data-fls-stepper]");
      var input = wrap.querySelector("input");
      var min = parseInt(input.min || "1", 10);
      var next = (parseInt(input.value, 10) || min) + parseInt(step.dataset.flsStep, 10);
      input.value = Math.max(min, next);
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });

    /* ---------------- retail: variant selection ---------------- */
    root.querySelectorAll("[data-fls-variants]").forEach(function (group) {
      var card = group.closest("[data-fls-card]");
      group.querySelectorAll("[data-fls-variant]").forEach(function (btn) {
        btn.addEventListener("click", function () {
          group.querySelectorAll("[data-fls-variant]").forEach(function (b) {
            b.setAttribute("aria-pressed", String(b === btn));
          });
          card.querySelector("[data-fls-variant-id]").value = btn.dataset.flsVariant;
          var now = card.querySelector("[data-fls-price-now]");
          var was = card.querySelector("[data-fls-price-was]");
          if (now) now.textContent = btn.dataset.flsPrice;
          if (was) {
            was.textContent = btn.dataset.flsCompare || "";
            was.hidden = !btn.dataset.flsCompare;
          }
        });
      });
    });

    /* ---------------- AJAX add to cart ---------------- */
    function refreshCart(openDrawer) {
      var drawer = document.querySelector("cart-drawer");
      var bubble = document.getElementById("cart-icon-bubble");
      var wanted = [];
      if (drawer) wanted.push("cart-drawer");
      if (bubble) wanted.push("cart-icon-bubble");
      if (!wanted.length) return Promise.resolve();
      return fetch(window.location.pathname + "?sections=" + wanted.join(","))
        .then(function (r) { return r.json(); })
        .then(function (sections) {
          if (sections["cart-drawer"] && drawer) {
            var html = new DOMParser().parseFromString(sections["cart-drawer"], "text/html");
            var fresh = html.querySelector("cart-drawer");
            if (fresh) drawer.innerHTML = fresh.innerHTML;
            drawer.classList.remove("is-empty");
            /* Held back only when a caller passes openDrawer: false. */
            if (openDrawer !== false && typeof drawer.open === "function") drawer.open();
          }
          if (sections["cart-icon-bubble"] && bubble) {
            var b = new DOMParser().parseFromString(sections["cart-icon-bubble"], "text/html");
            var freshB = b.getElementById("cart-icon-bubble");
            if (freshB) bubble.innerHTML = freshB.innerHTML;
          }
        });
    }

    function addItems(items, button, onDone, openDrawer) {
      if (!items.length) return;
      var original = button ? button.textContent : "";
      if (button) { button.disabled = true; button.textContent = "Adding\u2026"; }
      fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { return r.json(); })
        .then(function () { return refreshCart(openDrawer); })
        .then(function () {
          if (button) {
            button.textContent = "Added";
            setTimeout(function () { button.disabled = false; button.textContent = original; }, 1600);
          }
          if (onDone) onDone();
        })
        .catch(function () {
          if (button) { button.disabled = false; button.textContent = original; }
          window.location.href = window.Shopify.routes.root + "cart";
        });
    }

    root.querySelectorAll("[data-fls-form]").forEach(function (form) {
      form.addEventListener("submit", function (event) {
        event.preventDefault();
        var card = form.closest("[data-fls-card]");
        var id = form.querySelector("[data-fls-variant-id]").value;
        var qty = parseInt(form.querySelector("input[name='quantity']").value, 10) || 1;
        var item = { id: Number(id), quantity: qty };
        /* Seal Subscriptions injects its selling-plan inputs into the form; honour the selection. */
        var plan = form.querySelector("[name='selling_plan']:checked, [name='selling_plan']:not([type='radio'])");
        if (plan && plan.value && !plan.disabled) item.selling_plan = Number(plan.value);
        /* Wholesale: don't slide the drawer over the page — the reminder bar and the
           per-card link need to stay clickable. The cart count still updates. */
        var isCase = !!(card && card.dataset.flsUnits);
        addItems([item], form.querySelector("[data-fls-add]"), function () {
          revealMaterialNudges(card);
        }, !isCase);
        if (card) card.dispatchEvent(new CustomEvent("fls:added", { bubbles: true }));
      });
    });

    /* ---------------- wholesale: case tiers + materials ---------------- */
    function tiersFor(el) {
      try { return JSON.parse(el.dataset.flsTiers || "[]"); } catch (e) { return []; }
    }

    function tierAt(tiers, cases) {
      var hit = tiers[0];
      tiers.forEach(function (t) { if (cases >= t.min) hit = t; });
      return hit;
    }

    /* Sami renders its own quantity-break table into [data-sami-quantity-breaks].
       Read the tiers out of that table so the headline price always matches what the
       customer is actually charged, including custom per-customer pricing. */
    function parseMoney(text) {
      var n = parseFloat(String(text).replace(/[^0-9.,]/g, "").replace(/,/g, ""));
      return isNaN(n) ? null : Math.round(n * 100);
    }

    function samiTiers(card) {
      /* Sami injects its table wherever it likes inside the card, so scan the whole card
         rather than only our own [data-sami-quantity-breaks] hook. */
      var rows = card.querySelectorAll(
        "[data-sami-quantity-breaks] tr, [data-sami-quantity-breaks] [data-fls-tier], " +
        "[data-sami-quantity-breaks] .fls-tier, table tr, .fls-tier"
      );
      if (!rows.length) rows = card.querySelectorAll("tr");
      var out = [];
      rows.forEach(function (row) {
        if (row.querySelector("table")) return;
        var text = (row.textContent || "").replace(/\s+/g, " ").trim();
        var qty = text.match(/(\d+)\s*(?:-|\u2013|\u2014|\+)/);
        if (!qty) return;
        var tokens = text.match(/\$\s?[\d.,]+/g);
        if (!tokens) return;
        var cents = parseMoney(tokens[tokens.length - 1]);
        if (cents == null) return;
        out.push({ min: parseInt(qty[1], 10), total: cents, row: row });
      });
      out.sort(function (a, b) { return a.min - b.min; });
      return out;
    }

    function repriceCase(card) {
      var input = card.querySelector("input[name='quantity']");
      var cases = parseInt(input && input.value, 10) || 1;
      var units = parseInt(card.dataset.flsUnits, 10) || 1;
      var priceEl = card.querySelector("[data-fls-qprice]");
      var unitEl = card.querySelector("[data-fls-qunit]");

      var breaks = samiTiers(card);
      var caseCents;

      if (breaks.length) {
        var base = parseInt(card.dataset.flsPriceCents, 10) || 0;
        var inBreak = cases >= breaks[0].min;
        var hit = tierAt(breaks, cases);
        caseCents = inBreak ? hit.total : base;
        breaks.forEach(function (t) {
          t.row.dataset.active = String(inBreak && hit === t);
        });
      } else {
        var tiers = tiersFor(card);
        if (!tiers.length) return;
        var active = tierAt(tiers, cases);
        caseCents = active.unit * units;
        card.querySelectorAll("[data-fls-tier]").forEach(function (row) {
          row.dataset.active = String(parseInt(row.dataset.flsTier, 10) === active.min);
        });
      }

      if (priceEl) priceEl.textContent = money(caseCents, moneyFormat);
      if (unitEl) {
        unitEl.textContent =
          money(Math.round(caseCents / units), moneyFormat) +
          " per unit \u00b7 " + units + " units per case";
      }
    }

    var caseCards = root.querySelectorAll("[data-fls-card][data-fls-units]");
    caseCards.forEach(function (card) {
      repriceCase(card);
      /* Sami injects its table after load; reprice once it lands. */
      if (window.MutationObserver) {
        var seen = 0;
        new MutationObserver(function () {
          var n = samiTiers(card).length;
          if (n !== seen) { seen = n; repriceCase(card); }
        }).observe(card, { childList: true, subtree: true });
      }
      /* Belt and braces for apps that render late without mutating inside the card. */
      setTimeout(function () { repriceCase(card); }, 1200);
      setTimeout(function () { repriceCase(card); }, 3000);
      card.addEventListener("change", function () { repriceCase(card); });
      card.addEventListener("input", function () { repriceCase(card); });
    });

    /* ---------------- subscriptions (native selling plans) ---------------- */
    root.querySelectorAll("[data-fls-sub]").forEach(function (block) {
      var card = block.closest("[data-fls-card]");
      var form = block.closest("[data-fls-form]");
      var toggle = block.querySelector("[data-fls-sub-toggle]");
      var planInput = block.querySelector("[data-fls-sub-plan]");
      var saveEl = block.querySelector("[data-fls-sub-save]");
      var noteEl = block.querySelector("[data-fls-sub-note]");
      var priceNow = card && card.querySelector("[data-fls-price-now]");
      var priceWas = card && card.querySelector("[data-fls-price-was]");
      var plans = {};
      try { plans = JSON.parse(block.dataset.flsPlans || "{}"); } catch (e) { plans = {}; }

      /* Remember the one-time price so unticking restores it exactly. */
      var baseNow = priceNow ? priceNow.textContent.trim() : "";
      var baseWas = priceWas ? priceWas.textContent.trim() : "";
      var baseWasHidden = priceWas ? priceWas.hasAttribute("hidden") : true;

      function currentPlan() {
        var idInput = form && form.querySelector("[data-fls-variant-id]");
        return idInput ? plans[idInput.value] : null;
      }

      function sync() {
        var plan = currentPlan();
        var on = toggle.checked && !!plan;

        /* No plan for this variant: the option can't apply. */
        block.hidden = !plan;
        if (!plan) {
          toggle.checked = false;
          planInput.disabled = true;
          return;
        }

        planInput.value = plan.plan;
        planInput.disabled = !on;

        if (noteEl) noteEl.textContent = plan.name;

        if (on) {
          if (priceNow) priceNow.textContent = money(plan.price, moneyFormat);
          if (priceWas) {
            priceWas.textContent = baseNow;
            priceWas.removeAttribute("hidden");
          }
          if (saveEl) {
            saveEl.textContent = "You save " + money(basePriceCents(card) - plan.price, moneyFormat) + " per order";
            saveEl.removeAttribute("hidden");
          }
        } else {
          if (priceNow) priceNow.textContent = baseNow;
          if (priceWas) {
            priceWas.textContent = baseWas;
            if (baseWasHidden) priceWas.setAttribute("hidden", "");
          }
          if (saveEl) saveEl.setAttribute("hidden", "");
        }
      }

      /* The one-time price in cents, read back off the rendered price string. */
      function basePriceCents(c) {
        var n = parseFloat((baseNow || "").replace(/[^0-9.]/g, ""));
        return isNaN(n) ? 0 : Math.round(n * 100);
      }

      toggle.addEventListener("change", sync);
      /* Switching size changes both the base price and the plan. */
      if (card) {
        card.addEventListener("click", function (event) {
          if (!event.target.closest("[data-fls-variant]")) return;
          setTimeout(function () {
            baseNow = priceNow ? priceNow.textContent.trim() : "";
            baseWas = priceWas ? priceWas.textContent.trim() : "";
            baseWasHidden = priceWas ? priceWas.hasAttribute("hidden") : true;
            sync();
          }, 0);
        });
      }
      sync();
    });

    /* ---------------- reviews dialog ---------------- */
    var rmodal = root.querySelector("[data-fls-rmodal]");
    if (rmodal) {
      var rTitle = rmodal.querySelector("[data-fls-rmodal-title]");
      var rBody = rmodal.querySelector("[data-fls-rmodal-body]");
      var rLink = rmodal.querySelector("[data-fls-rmodal-link]");

      function closeReviews() {
        rmodal.hidden = true;
        rBody.innerHTML = "";
      }

      rmodal.querySelectorAll("[data-fls-rmodal-close]").forEach(function (el) {
        el.addEventListener("click", closeReviews);
      });
      document.addEventListener("keydown", function (e) {
        if (e.key === "Escape" && !rmodal.hidden) closeReviews();
      });

      root.addEventListener("click", function (event) {
        var link = event.target.closest("[data-fls-reviews]");
        if (!link) return;
        event.preventDefault();
        rTitle.textContent = link.dataset.flsReviewTitle || "Reviews";
        rLink.href = link.dataset.flsReviewUrl + "#looxReviews";
        rBody.innerHTML =
          '<div id="looxReviews" data-product-id="' + link.dataset.flsReviewProduct + '"></div>';
        rmodal.hidden = false;
        /* Loox renders into #looxReviews on demand. */
        if (window.loox && typeof window.loox.reload === "function") {
          window.loox.reload();
        } else if (window.Loox && typeof window.Loox.init === "function") {
          window.Loox.init();
        }
      });
    }

    /* ---------------- materials nudges ---------------- */
    function closeDrawer() {
      var drawer = document.querySelector("cart-drawer");
      if (drawer && typeof drawer.close === "function") drawer.close();
      document.body.classList.remove("overflow-hidden");
    }

    var nudge = root.querySelector("[data-fls-nudge]");
    var nudgeDismissed = false;

    function groupFor(card) {
      var handle = card && (card.dataset.flsMgroup || card.dataset.flsHandle);
      return handle ? root.querySelector('[data-fls-mgroup="' + handle + '"]') : null;
    }

    function scrollToEl(el) {
      if (!el) return;
      closeDrawer();
      var top = el.getBoundingClientRect().top + window.pageYOffset - 90;
      window.scrollTo({ top: top, behavior: "smooth" });
      el.dataset.flsFlash = "true";
      setTimeout(function () { delete el.dataset.flsFlash; }, 2200);
    }

    /* After a case is added: point at that product's group, and raise the sticky bar. */
    function revealMaterialNudges(card) {
      if (card && groupFor(card)) {
        var btn = card.querySelector("[data-fls-card-nudge]");
        if (btn) btn.hidden = false;
      }
      if (nudge && !nudgeDismissed) nudge.hidden = false;
    }

    root.addEventListener("click", function (event) {
      var btn = event.target.closest("[data-fls-card-nudge]");
      if (!btn) return;
      scrollToEl(groupFor(btn.closest("[data-fls-card]")));
    });

    if (nudge) {
      nudge.querySelector("[data-fls-nudge-go]").addEventListener("click", function () {
        scrollToEl(root.querySelector("[data-fls-materials]"));
      });
      nudge.querySelector("[data-fls-nudge-close]").addEventListener("click", function () {
        nudgeDismissed = true;
        nudge.hidden = true;
      });
      /* Once they've picked materials, the reminder has done its job. */
      root.addEventListener("change", function (event) {
        if (!event.target.closest("[data-fls-material-check]")) return;
        nudgeDismissed = true;
        nudge.hidden = true;
      });
    }

    /* Match a materials group back to its product card to read the case count. */
    function casesOrderedFor(productTitle) {
      var n = 1;
      if (!productTitle) return n;
      root.querySelectorAll("[data-fls-card]").forEach(function (card) {
        var name = card.querySelector(".fls-card__name");
        if (!name || name.textContent.trim() !== productTitle) return;
        var input = card.querySelector("input[name='quantity']");
        n = parseInt(input && input.value, 10) || 1;
      });
      return n;
    }

    /* Materials and samples: add every ticked item in one request. */
    var materialsSubmit = root.querySelector("[data-fls-materials-submit]");
    if (materialsSubmit) {
      materialsSubmit.addEventListener("click", function () {
        var items = [];
        materialsSubmit
          .closest("[data-fls-materials]")
          .querySelectorAll("[data-fls-material-check]")
          .forEach(function (box) {
            if (!box.checked) return;
            var row = box.closest("[data-fls-material-row]");
            var qty = 1;
            /* Sample packs: one pack of 25 per case of the product they sit under. */
            if (row && row.hasAttribute("data-fls-sample")) {
              var group = row.closest(".fls-mcard");
              var title = group && group.querySelector(".fls-mcard__title");
              qty = casesOrderedFor(title ? title.textContent.trim() : "");
            }
            items.push({ id: Number(box.value), quantity: qty });
          });
        if (!items.length) {
          materialsSubmit.textContent = "Tick an item first";
          setTimeout(function () { materialsSubmit.textContent = "Add selected materials"; }, 1600);
          return;
        }
        addItems(items, materialsSubmit);
      });
    }
  }

  document.querySelectorAll("[data-fls-root]").forEach(init);
  document.addEventListener("shopify:section:load", function (event) {
    var root = event.target.querySelector("[data-fls-root]");
    if (root) init(root);
  });
})();
